import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { fetcher_default } from "./chunk-GONJSORR.mjs";
import { __export } from "./chunk-QK4PKNB3.mjs"; // src/services/food.ts

var food_exports = {};

__export(food_exports, {
  getFoodStuffGroups: function getFoodStuffGroups() {
    return _getFoodStuffGroups;
  },
  searchFoodStuffs: function searchFoodStuffs() {
    return _searchFoodStuffs;
  }
});

import _ from "lodash";

var getQueryObj = function getQueryObj(_ref) {
  var type = _ref.type,
      category = _ref.category,
      keyword = _ref.keyword;
  if (!_.isEmpty(keyword)) return {
    q: keyword
  };
  if (type === "brand") return {
    q: category
  };
  if (type === "category") return {
    category: category
  };
  return {};
};

var _searchFoodStuffs = function _searchFoodStuffs(type, category) {
  var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var keyword = arguments.length > 3 ? arguments[3] : undefined;
  var queryObj = getQueryObj({
    type: type,
    category: category,
    keyword: keyword
  });
  return fetcher_default.get("/v4/food_stuffs/search", _objectSpread(_objectSpread({}, queryObj), {}, {
    page: page
  }));
};

var _getFoodStuffGroups = function _getFoodStuffGroups() {
  return fetcher_default.get("/v4/food_stuffs/groups");
};

export { _searchFoodStuffs as searchFoodStuffs, _getFoodStuffGroups as getFoodStuffGroups, food_exports };